import baseForm from './form/form.js';
import gljySelect from './select/gljy-select.vue';
import gljyRadio from './radio/gljy-radio.vue';
import gljyTreeSelect from './select/gljy-tree-select.vue';
import gljyUpload from './upload/gljy-upload.vue';
import gljyDataImport from './upload/gljy-data-import.vue';
import gljyTable from './table/gljy-table.vue';
import gljyDatePicker from './date-picker/gljy-date-picker.vue';
import gljyTree from './tree/gljy-tree.vue';
import gljyFile from './file/gljy-file.vue';
import tableCloumnOperate from './table/table-column-operate.vue';
import mapContainer from './map/map-container.vue';
import gljyDialog from './dialog/gljy-dialog.vue';
import gljyWeather from './weather/gljy-weather.vue';
import screenFull from './screen-full/screen-full.vue';
const components = [
    gljySelect,
    gljyRadio,
    gljyTree,
    gljyTreeSelect,
    gljyUpload,
    gljyDataImport,
    gljyDatePicker,
    gljyTable,
    gljyFile,
    tableCloumnOperate,
    mapContainer,
    gljyDialog,
    gljyWeather,
    screenFull,
    ...baseForm
];

const install = function (Vue) {
    if (install.installed) return
    components.map(component => Vue.component(component.name, component))
}

export default {
    install,
    gljySelect,
    gljyRadio,
    gljyTree,
    gljyTreeSelect,
    gljyUpload, gljyDataImport,
    gljyDatePicker,
    gljyTable,
    gljyFile,
    tableCloumnOperate,
    mapContainer,
    gljyDialog,
    gljyWeather,
    screenFull,
    ...baseForm
}
